import DeleteCategory from './DeleteCategory'
export default DeleteCategory